import { isServer, useIsWindowBiggerThan } from '@bob/library'
import { useEffect, useState } from 'react'

export const useReversedLayout = (reversed_layout: boolean) => {
  const [reversedLayout, setReversedLayout] = useState<boolean>(reversed_layout)
  const layoutForDevice = !useIsWindowBiggerThan(1023)

  useEffect(() => {
    if (!isServer) {
      setReversedLayout(layoutForDevice || reversed_layout)
    }
  }, [layoutForDevice, reversed_layout])

  return reversedLayout
}
